import React, {PureComponent, ReactNode} from 'react';
import {timeStampToTime} from 'app/utils';
import {pushAnalyticsEvent} from 'app/utils/analytics';

interface ContentProps {
    articleId?: number | null
    articleType?: string
    date: number
    content: string
    trackInternalLinks?: boolean
}

export default class Content extends PureComponent<ContentProps> {
    handleClick = (event: React.MouseEvent<HTMLDivElement>): void => {
        if (!this.props.trackInternalLinks) {
            return;
        }

        const target = event.target as HTMLElement;
        const link = target.closest('a') as HTMLAnchorElement | null;

        if (!link?.href) {
            return;
        }

        const url = new URL(link.href, window.location.origin);

        if (url.origin !== window.location.origin) {
            return;
        }

        pushAnalyticsEvent('seo_internal_link_click', {
            article_id: this.props.articleId,
            article_type: this.props.articleType,
            link_path: url.pathname
        });
    };

    render(): ReactNode {
        const {date, content} = this.props;
        return <div className="content__holder">
            <div className="article">
                <div className="content__date">{timeStampToTime(date)}</div>
                <div onClick={this.handleClick} dangerouslySetInnerHTML={{__html: content}}/>
            </div>
        </div>;
    }
}
